import React, { Component, createRef } from 'react';
import { bool, func, node, string } from 'prop-types';

import {
  CancelButton,
  SubmitButton,
} from 'apps/journey/pages/professional-center/components/prof-center-modal/styled-prof-center-modal';
import JourneySideModal from 'apps/journey/components/modals/journey-side-modal';

/**
 * Modal that accepts any children to be rendered, a heading component and
 * an optional modalDetailText component.
 *
 * Expects an 'actionButton' component that takes a 'handleSubmit' prop,
 * which is provided by the parent and passed to the actionButton component.
 */
class ProfCenterModal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = createRef();
  }

  static propTypes = {
    active: bool,
    toggleActive: func,
    children: node,
    modalHeading: node,
    modalDetailText: string,
    actionButton: node,
    handleSubmit: func,
    submitText: string,
    loading: bool,
    renderCancelButton: bool,
    icon: node,
    disableSubmit: bool,
  };

  static defaultProps = {
    actionButton: ({ handleSubmit, disabled, submitText = 'Create' }) => (
      <SubmitButton disabled={disabled} onClick={handleSubmit}>
        {submitText}
      </SubmitButton>
    ),
    renderCancelButton: true,
  };

  componentDidMount = () => {
    this.modalRef.current?.focus();
  };

  render() {
    const {
      active,
      toggleActive,
      modalHeading,
      modalDetailText,
      children,
      actionButton,
      handleSubmit,
      submitText,
      renderCancelButton,
      loading,
      icon,
      disableSubmit,
    } = this.props;

    const ActionButton = actionButton;

    return (
      <JourneySideModal
        tabIndex={0}
        active={active}
        toggleActive={toggleActive}
        header={modalHeading}
        description={modalDetailText}
        icon={icon}
        footer={
          <>
            {renderCancelButton && (
              <CancelButton onClick={toggleActive}>Close</CancelButton>
            )}
            <ActionButton
              disabled={disableSubmit}
              loading={loading}
              handleSubmit={handleSubmit}
              submitText={submitText}
            />
          </>
        }
      >
        {children}
      </JourneySideModal>
    );
  }
}

export default ProfCenterModal;
